import { ReactElement, useEffect } from 'react';

type WrapperRouteComponentProps = {
    title: string;
    children: ReactElement;
};

/**
 * Wrapper component for managing page/module titles
 * @param title - Title displayed on the browser tab
 * @param children - Child component to render
 */
export default function WrapperRouteComponent({ title, children }: WrapperRouteComponentProps) {
    useEffect(() => {
        // Set document title khi component mount
        if (title) {
            document.title = `${title} - NezenX Admin`;
        }

        // Cleanup function to reset title when the component unmounts
        return () => {
            document.title = 'NezenX Admin';
        };
    }, [title]);

    return children;
}

